<template>
  <button
    @click.stop.prevent="$emit('setUom')"
    class="inline-block w-full pl-3 pr-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
  >
    <span class="w-6 inline-block pr-2">
      <IconClock v-if="name == 'time'"></IconClock>
      <IconTag v-else></IconTag>
    </span>
    <span class="block -mt-6 ml-6">{{ unit }}</span>
  </button>
</template>

<script>
import IconClock from '@/components/icons/IconClock'
import IconTag from '@/components/icons/IconTag'

export default {
  name: 'RowUomButton',
  props: {
    name: String,
    unit: String
  },
  components: {
    IconClock,
    IconTag
  }
};
</script>
